import { inject, Pipe, PipeTransform } from '@angular/core';
import { InProgressPrintSettings } from 'app/core/models/treatment/in-progress-print-settings';
import { getApplianceTypeNameByTreatmentAndApplianceType } from 'app/core/helpers';
import { TreatmentApplianceType, TreatmentType } from 'app/core/enums';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'resinLabel',
  standalone: true,
})
export class ResinLabelPipe implements PipeTransform {
  private readonly _translateService = inject(TranslateService);

  transform(
    resin: InProgressPrintSettings | TreatmentApplianceType,
    treatmentTypeId: TreatmentType,
    isV2_0 = true
  ): string {
    const applianceType = typeof resin === 'number' ? resin : resin.treatmentApplianceType;
    const name = getApplianceTypeNameByTreatmentAndApplianceType(treatmentTypeId, applianceType, isV2_0);

    return name
      ? `${this.translateMsg(name)} ${this.translateMsg(`general.material`)}`
      : `${this.translateMsg(`general.material`)}`;
  }

  private translateMsg(value: string, args?: any): string {
    return this._translateService.instant(value, args);
  }
}
